// The four KYC documents an Anna uploads for verification. Each lives at
// drivers/<uid>.documents.<key> with a `status` of 'pending' | 'verified' |
// 'rejected' (absent = never uploaded).
export const DOC_KEYS = ['drivingLicence', 'rc', 'insurance', 'aadhaar'];

// Passenger-facing vehicle safety records are deliberately separate from KYC.
// Aadhaar/DL verification must not be treated as proof of vehicle roadworthiness.
export const VEHICLE_SAFETY_KEYS = ['rc', 'insurance', 'drivingLicence'];

/** True when the Anna has at least one uploaded document awaiting a decision. */
export const hasDocPendingReview = (driver) =>
  DOC_KEYS.some((k) => driver?.documents?.[k]?.status === 'pending');

/** Count of this Anna's documents that have been verified (out of the 4). */
export const verifiedDocCount = (driver) =>
  DOC_KEYS.filter((k) => driver?.documents?.[k]?.status === 'verified').length;

/** True when at least `min` of the Anna's documents have been verified. */
export const hasMinVerifiedDocs = (driver, min = 3) => verifiedDocCount(driver) >= min;

export const vehicleSafetyVerifiedCount = (driver) =>
  VEHICLE_SAFETY_KEYS.filter((key) => driver?.vehicleSafety?.[key]?.status === 'valid').length;

export const hasMinVehicleSafetyDocs = (driver, min = 3) =>
  vehicleSafetyVerifiedCount(driver) >= min;

/** Millis of the driver's last write — used to float the most recent uploader
 *  to the top of the review queue. */
export const driverUpdatedMillis = (driver) => {
  const u = driver?.updatedAt;
  if (u?.toMillis) return u.toMillis();
  if (typeof u === 'number') return u;
  if (u?.seconds) return u.seconds * 1000;
  return 0;
};
